import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { EncryptDecryptService } from '../services/encrypt-decrypt.service';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class mainGuard implements CanActivate {
  isjwtToken: any;
  constructor(
    private router: Router,
    private encryptDecryptService: EncryptDecryptService,
    private authService: AuthService
  ) {}

  canActivate(): boolean {
    
    const encryptedData = sessionStorage.getItem('u.');
    this.authService.returnUrl = sessionStorage.getItem('returnUrl');
    if (encryptedData !== null) {
      const decryptedData = this.encryptDecryptService.decryptUsingAES256(encryptedData);
      let userDetails = JSON.parse(decryptedData);
      this.isjwtToken = userDetails.token;
      if (this.isjwtToken) {
        const decodedToken: any = this.encryptDecryptService.decodeJwtToken(this.isjwtToken);
        if (decodedToken.exp && decodedToken.exp * 1000 < Date.now()) {
          if (this.authService.returnUrl !== null) {
            const decryptedData = this.encryptDecryptService.decryptUsingAES256(this.authService.returnUrl);
            this.router.navigateByUrl(JSON.parse(decryptedData));
          }
          else{
            this.router.navigateByUrl('/login');
          }
          return false;
        } else {
         
          return true;
        }
      }
    }

    if(this.authService.returnUrl  !== null ){
      const decryptedData = this.encryptDecryptService.decryptUsingAES256(this.authService.returnUrl);
      this.router.navigateByUrl(JSON.parse(decryptedData));
      return false;
    }
    else{
      this.router.navigateByUrl('/login');
      return false;
    }
  }
}
